import styled from "styled-components";

export const StyledTr = styled.tr`
  height: 24px;
`;
